import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import DefaultHeader from './_shared/DefaultHeader';

const MenuDesktop = dynamic(() => import('./_shared/Menu/MenuDesktop'));
const DefaultFooter = dynamic(() => import('./_shared/DefaultFooter'));

const Layout = ({ children }) => (
  <React.Fragment>
    <DefaultHeader />
    <MenuDesktop />
    {children}
    <DefaultFooter />
  </React.Fragment>
);

Layout.propTypes = {
  children: PropTypes.any
};

export default Layout;
